module.exports = __webpack_public_path__ + "static/media/logo.d09d720d.svg";